import {API_ROOT_URL} from 'envs/_current/config'
import {schema} from 'normalizr'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'

export const gameQuestionOptionSchema = new schema.Entity(
  'game_question_options',
  {},
  {
    idAttribute: 'id',
  }
)

export const gameQuestionSchema = new schema.Entity(
  'game_questions',
  {
    game_question_options: [gameQuestionOptionSchema],
  },
  {
    idAttribute: 'id',
  }
)

export const gameSchema = new schema.Entity(
  'games',
  {},
  {
    idAttribute: 'idname',
  }
)

export const gamePlayAnswerSchema = new schema.Entity(
  'game_play_answers',
  {},
  {
    idAttribute: 'id',
  }
)

export const gamePlayQuestionSchema = new schema.Entity(
  'game_play_questions',
  {
    game_play_answers: [gamePlayAnswerSchema],
  },
  {
    idAttribute: 'id',
  }
)

export const gamePlaySchema = new schema.Entity(
  'game_plays',
  {
    game_play_questions: [gamePlayQuestionSchema],
  },
  {
    idAttribute: 'id',
  }
)

// ─── Games (thư viện) ───────────────────────────────────────────────────────

// Route::get('games/get-games', 'GameController@getGames');
export const game_getGames_Api = {
  name: 'game_getGames',
  backend: `Route::get('games/get-games', 'GameController@getGames');`,
  root: API_ROOT_URL,
  path: '/games/get-games',
  method: 'GET',
  paramsFields: ['keyword', 'primary_answer_type', 'topic', 'age_group', 'difficulty', 'language', 'owner_type', 'owner_id', 'sort_by'],
  schema: gameSchema,
  transform: createListTransform(gameSchema),
}

// Route::get('games/get-preview-question', 'GameController@getPreviewQuestion');
export const game_getPreviewQuestion_Api = {
  name: 'game_getPreviewQuestion',
  backend: `Route::get('games/get-preview-question', 'GameController@getPreviewQuestion');`,
  root: API_ROOT_URL,
  path: '/games/get-preview-question',
  method: 'GET',
}

// Route::get('games/get-game-type-counts', 'GameController@getGameTypeCounts');
export const game_getGameTypeCounts_Api = {
  name: 'game_getGameTypeCounts',
  backend: `Route::get('games/get-game-type-counts', 'GameController@getGameTypeCounts');`,
  root: API_ROOT_URL,
  path: '/games/get-game-type-counts',
  method: 'GET',
}

// Route::get('games/get-library-stats', 'GameController@getLibraryStats');
export const game_getLibraryStats_Api = {
  name: 'game_getLibraryStats',
  backend: `Route::get('games/get-library-stats', 'GameController@getLibraryStats');`,
  root: API_ROOT_URL,
  path: '/games/get-library-stats',
  method: 'GET',
}

// Route::get('games/get-top-owners', 'GameController@getTopOwners');
export const game_getTopOwners_Api = {
  name: 'game_getTopOwners',
  backend: `Route::get('games/get-top-owners', 'GameController@getTopOwners');`,
  root: API_ROOT_URL,
  path: '/games/get-top-owners',
  method: 'GET',
  paramsFields: ['limit'],
}

// Route::get('games/get-top-players', 'GameController@getTopPlayers');
export const game_getTopPlayers_Api = {
  name: 'game_getTopPlayers',
  backend: `Route::get('games/get-top-players', 'GameController@getTopPlayers');`,
  root: API_ROOT_URL,
  path: '/games/get-top-players',
  method: 'GET',
  paramsFields: ['limit'],
}

// Route::get('games/game/{id}/get', 'GameController@getById');
export const game_getById_Api = {
  name: 'game_getById',
  backend: `Route::get('games/game/{id}/get', 'GameController@getById');`,
  root: API_ROOT_URL,
  path: '/games/game/:id/get',
  method: 'GET',
  schema: gameSchema,
  transform: createTransform(gameSchema, 'data'),
}

// Route::get('games/get-my-games', 'GameController@getMyGames');
export const game_getMyGames_Api = {
  name: 'game_getMyGames',
  backend: `Route::get('games/get-my-games', 'GameController@getMyGames');`,
  root: API_ROOT_URL,
  path: '/games/get-my-games',
  method: 'GET',
  schema: gameSchema,
  transform: createListTransform(gameSchema),
}

// Route::post('games/{type}/{id}/add', 'GameController@createGame');
// Tab "Góc trò chơi" trong Workspace - CHỈ games thuộc owner_type/owner_id truyền vào, khác
// game_getGames_Api (thư viện công khai, không lọc owner - dùng nhầm sẽ lộ games của org khác)
export const game_getGamesByOwner_Api = {
  name: 'game_getGamesByOwner',
  backend: `Route::get('games/{type}/{id}/gets', 'GameController@getGamesByOwner');`,
  root: API_ROOT_URL,
  path: '/games/:type/:id/gets',
  method: 'GET',
  paramsFields: ['keyword'],
  schema: gameSchema,
  transform: createListTransform(gameSchema),
}

export const game_createGame_Api = {
  name: 'game_createGame',
  backend: `Route::post('games/{type}/{id}/add', 'GameController@createGame');`,
  root: API_ROOT_URL,
  path: '/games/:type/:id/add',
  method: 'POST',
  fields: ['title', 'description', 'cover_photo', 'primary_answer_type', 'topic', 'age_group', 'difficulty', 'language',
    'hearts_limit', 'total_of_questions', 'point_per_question', 'time_open', 'time_close',
    'duration_minutes', 'pass_score', 'credit_score', 'distinction_score', 'max_attempts',
    'is_fixed_questions', 'is_fixed_orders', 'is_auto_scoring', 'is_hidden_question_list',
    'display_result_on_final', 'privacy', 'status'],
  schema: gameSchema,
  transform: createTransform(gameSchema, 'data'),
}

// Route::post('games/game/{id}/edit', 'GameController@editGame');
export const game_editGame_Api = {
  name: 'game_editGame',
  backend: `Route::post('games/game/{id}/edit', 'GameController@editGame');`,
  root: API_ROOT_URL,
  path: '/games/game/:id/edit',
  method: 'POST',
  fields: ['title', 'description', 'cover_photo', 'primary_answer_type', 'topic', 'age_group', 'difficulty', 'language',
    'hearts_limit', 'total_of_questions', 'point_per_question', 'time_open', 'time_close',
    'duration_minutes', 'pass_score', 'credit_score', 'distinction_score', 'max_attempts',
    'is_fixed_questions', 'is_fixed_orders', 'is_auto_scoring', 'is_hidden_question_list',
    'display_result_on_final', 'privacy', 'status'],
  schema: gameSchema,
  transform: createTransform(gameSchema, 'data'),
}

// Route::post('games/game/{id}/delete', 'GameController@deleteGame');
export const game_deleteGame_Api = {
  name: 'game_deleteGame',
  backend: `Route::post('games/game/{id}/delete', 'GameController@deleteGame');`,
  root: API_ROOT_URL,
  path: '/games/game/:id/delete',
  method: 'POST',
}

// ─── Game Questions (biên soạn) ─────────────────────────────────────────────

// Route::get('games/game/{id}/get-game-questions', 'GameQuestionController@getGameQuestions');
export const game_getGameQuestions_Api = {
  name: 'game_getGameQuestions',
  backend: `Route::get('games/game/{id}/get-game-questions', 'GameQuestionController@getGameQuestions');`,
  root: API_ROOT_URL,
  path: '/games/game/:id/get-game-questions',
  method: 'GET',
  schema: gameQuestionSchema,
  transform: createListTransform(gameQuestionSchema),
}

// Route::post('games/game/{id}/create-game-question', 'GameQuestionController@createGameQuestion');
export const game_createGameQuestion_Api = {
  name: 'game_createGameQuestion',
  backend: `Route::post('games/game/{id}/create-game-question', 'GameQuestionController@createGameQuestion');`,
  root: API_ROOT_URL,
  path: '/games/game/:id/create-game-question',
  method: 'POST',
  fields: ['answer_type', 'question_text', 'explanation', 'photo', 'point', 'order_sort'],
  schema: gameQuestionSchema,
  transform: createTransform(gameQuestionSchema, 'data'),
}

// Route::post('game-questions/game-question/{id}/edit', 'GameQuestionController@editGameQuestion');
export const game_editGameQuestion_Api = {
  name: 'game_editGameQuestion',
  backend: `Route::post('game-questions/game-question/{id}/edit', 'GameQuestionController@editGameQuestion');`,
  root: API_ROOT_URL,
  path: '/game-questions/game-question/:id/edit',
  method: 'POST',
  fields: ['question_text', 'explanation', 'photo', 'point', 'order_sort', 'status'],
  schema: gameQuestionSchema,
  transform: createTransform(gameQuestionSchema, 'data'),
}

// Route::post('game-questions/game-question/{id}/delete', 'GameQuestionController@deleteGameQuestion');
export const game_deleteGameQuestion_Api = {
  name: 'game_deleteGameQuestion',
  backend: `Route::post('game-questions/game-question/{id}/delete', 'GameQuestionController@deleteGameQuestion');`,
  root: API_ROOT_URL,
  path: '/game-questions/game-question/:id/delete',
  method: 'POST',
}

// Route::post('game-questions/game-question/{id}/create-option', 'GameQuestionController@createGameQuestionOption');
export const game_createGameQuestionOption_Api = {
  name: 'game_createGameQuestionOption',
  backend: `Route::post('game-questions/game-question/{id}/create-option', 'GameQuestionController@createGameQuestionOption');`,
  root: API_ROOT_URL,
  path: '/game-questions/game-question/:id/create-option',
  method: 'POST',
  fields: ['title', 'order_sort', 'is_correct', 'ref_id'],
  schema: gameQuestionOptionSchema,
  transform: createTransform(gameQuestionOptionSchema, 'data'),
}

// Route::post('game-question-options/game-question-option/{id}/edit', 'GameQuestionController@editGameQuestionOption');
export const game_editGameQuestionOption_Api = {
  name: 'game_editGameQuestionOption',
  backend: `Route::post('game-question-options/game-question-option/{id}/edit', 'GameQuestionController@editGameQuestionOption');`,
  root: API_ROOT_URL,
  path: '/game-question-options/game-question-option/:id/edit',
  method: 'POST',
  fields: ['title', 'order_sort', 'is_correct', 'ref_id'],
  schema: gameQuestionOptionSchema,
  transform: createTransform(gameQuestionOptionSchema, 'data'),
}

// Route::post('game-question-options/game-question-option/{id}/delete', 'GameQuestionController@deleteGameQuestionOption');
export const game_deleteGameQuestionOption_Api = {
  name: 'game_deleteGameQuestionOption',
  backend: `Route::post('game-question-options/game-question-option/{id}/delete', 'GameQuestionController@deleteGameQuestionOption');`,
  root: API_ROOT_URL,
  path: '/game-question-options/game-question-option/:id/delete',
  method: 'POST',
}

// Route::post('game-questions/game-question/{id}/sort-options', 'GameQuestionController@sortGameQuestionOptions');
export const game_sortGameQuestionOptions_Api = {
  name: 'game_sortGameQuestionOptions',
  backend: `Route::post('game-questions/game-question/{id}/sort-options', 'GameQuestionController@sortGameQuestionOptions');`,
  root: API_ROOT_URL,
  path: '/game-questions/game-question/:id/sort-options',
  method: 'POST',
  fields: ['game_question_option_ids'],
  schema: gameQuestionOptionSchema,
  transform: createListTransform(gameQuestionOptionSchema),
}

// ─── Game Plays (chơi/nộp bài) ──────────────────────────────────────────────

// Route::post('games/game/{id}/play/init', 'GamePlayController@createGamePlay');
export const game_createGamePlay_Api = {
  name: 'game_createGamePlay',
  backend: `Route::post('games/game/{id}/play/init', 'GamePlayController@createGamePlay');`,
  root: API_ROOT_URL,
  path: '/games/game/:id/play/init',
  method: 'POST',
  schema: gamePlaySchema,
  transform: createTransform(gamePlaySchema, 'data'),
}

// Route::get('game-plays/game-play/{id}/get', 'GamePlayController@getGamePlayById');
export const game_getGamePlayById_Api = {
  name: 'game_getGamePlayById',
  backend: `Route::get('game-plays/game-play/{id}/get', 'GamePlayController@getGamePlayById');`,
  root: API_ROOT_URL,
  path: '/game-plays/game-play/:id/get',
  method: 'GET',
  schema: gamePlaySchema,
  transform: createTransform(gamePlaySchema, 'data'),
}

// Route::post('game-plays/game-play-question/{id}/answer', 'GamePlayController@submitAnswer');
export const game_submitAnswer_Api = {
  name: 'game_submitAnswer',
  backend: `Route::post('game-plays/game-play-question/{id}/answer', 'GamePlayController@submitAnswer');`,
  root: API_ROOT_URL,
  path: '/game-plays/game-play-question/:id/answer',
  method: 'POST',
  fields: ['game_question_option_id', 'submitted_text', 'positions', 'pairs'],
  schema: gamePlayQuestionSchema,
  transform: createTransform(gamePlayQuestionSchema, 'data'),
}

// Route::post('game-plays/game-play/{id}/submit', 'GamePlayController@submitGamePlay');
export const game_submitGamePlay_Api = {
  name: 'game_submitGamePlay',
  backend: `Route::post('game-plays/game-play/{id}/submit', 'GamePlayController@submitGamePlay');`,
  root: API_ROOT_URL,
  path: '/game-plays/game-play/:id/submit',
  method: 'POST',
  schema: gamePlaySchema,
  transform: createTransform(gamePlaySchema, 'data'),
}

// Route::get('games/game/{id}/leaderboard', 'GamePlayController@getLeaderboard');
export const game_getLeaderboard_Api = {
  name: 'game_getLeaderboard',
  backend: `Route::get('games/game/{id}/leaderboard', 'GamePlayController@getLeaderboard');`,
  root: API_ROOT_URL,
  path: '/games/game/:id/leaderboard',
  method: 'GET',
  schema: gamePlaySchema,
  transform: createListTransform(gamePlaySchema),
}

// Route::get('game-plays/get-my-plays', 'GamePlayController@getMyPlays');
export const game_getMyPlays_Api = {
  name: 'game_getMyPlays',
  backend: `Route::get('game-plays/get-my-plays', 'GamePlayController@getMyPlays');`,
  root: API_ROOT_URL,
  path: '/game-plays/get-my-plays',
  method: 'GET',
  schema: gamePlaySchema,
  transform: createListTransform(gamePlaySchema),
}

// Route::get('game-plays/get-my-stats', 'GamePlayController@getMyStats');
export const game_getMyStats_Api = {
  name: 'game_getMyStats',
  backend: `Route::get('game-plays/get-my-stats', 'GamePlayController@getMyStats');`,
  root: API_ROOT_URL,
  path: '/game-plays/get-my-stats',
  method: 'GET',
}
